import React from 'react';
import { useAuth } from '../../services/useAuth';
import { SiteLink, useRouter } from '../../../../components';
import env from '../../../../env';
// import { useUsers } from '../../users/users';

export function Login(props) {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [agreed, setAgreed] = React.useState(false);
  const auth = useAuth();

  const router = useRouter();

  function submit(e) {
    setPending(true);
    //console.log('loggin', username, password)
    e.preventDefault();
    e.stopPropagation();
    setPending(true);

    auth.signin(username, password).then(async firebaseUser => {
      // console.log("USER",firebaseUser)
      
      try {
        // After successful Firebase login, fetch user info from API
        const response = await fetch(env.apiBase + `/api/Users/GetUserByEmail/${encodeURIComponent(firebaseUser.email)}`, {
          headers: {
            'Authorization': `Bearer ${await firebaseUser.getIdToken()}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to get user info');
        }
        
        const result = await response.json();
        const userInfo = result.results?.userinfo;
        
        if (userInfo) {
          // Check memberType (0 = regular user, 99 = admin) AND profileStatus (0 = active)
          const isAllowedMemberType = userInfo.memberType === 0 || userInfo.memberType === 99;
          const isActiveProfile = userInfo.profileStatus === 0;
          
          if (isAllowedMemberType && isActiveProfile) {
            setPending(false);
            setError('');
            router.push('/members-area');
          } else if (!isAllowedMemberType) {
            // Not an allowed member type
            setPending(false);
            setError('Access denied. You do not have permission to access this area.');
            await auth.signout();
          } else if (!isActiveProfile) {
            // Account is not active
            setPending(false);
            setError('Your account is not active. Please contact support.');
            await auth.signout();
          }
        } else {
          // User not found in API data
          setPending(false);
          setError('User not found');
          await auth.signout();
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
        setPending(false);
        setError('Failed to load user information');
      }
    }).catch(error => {
      setPending(false);
      setError(error.message)
    })

  }
  return (
    <div className="sign-in auth-panel"  style={{maxWidth: '600px', margin: 'auto'}}>
      <h1>Log In</h1>
      <div className="loading-panel-holder" >
        {/* <app-loading [loadingStatus]="loadingStatus"></app-loading> */}
        <div className="panel-content">
          <form method="POST" noValidate="" onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" className="form-control" name="email" required autoFocus
                onChange={event => {
                  setUsername(event.target.value);
                }} />
              <div className="invalid-feedback">
                Email is invalid
          </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" className="form-control" name="password" required
                onChange={event => {
                  setPassword(event.target.value);
                }} />
              <div className="invalid-feedback">
                Password is required
              </div>
              <div style={{textAlign: 'right', marginTop: '5px'}}>
                <SiteLink to="/forgot-password" style={{color: '#e21d20', fontSize: '0.9rem'}}>
                  Forgot Password?
                </SiteLink>
              </div>
            </div>
            {/* 
        <!-- <div className="form-group">
                  <div className="custom-checkbox custom-control">
            <input type="checkbox" name="remember" id="remember" className="custom-control-input" #remember>
                    <label for="remember" className="custom-control-label">Remeber Me</label>
                  </div>
        </div> --> */}

            <div className="form-group">
              <div className='form-check'>
                <input type="checkbox" name="privacy" id="privacy" className="form-check-input" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} required />
                <label htmlFor="remember" className="custom-control-label">
                  I agree to the <SiteLink to="/privacy">Privacy and Confidentiality Policy</SiteLink>
                </label>
              </div>
            </div>

            <div className="form-group m-0">
              <button type="submit" disabled={pending} className="btn btn-primary btn-block">
                {pending && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                <span className="">Log In</span>
              </button>
            </div>

            {error && <div style={{color: 'red'}}>{error}</div>}

            <div className="text-center mt-3">
              Don't have an account?{' '}
              <SiteLink to="/sign-up" style={{color: '#e21d20', fontWeight: 'bold', textDecoration: 'underline'}}>
                Sign up
              </SiteLink>
            </div>

          </form>

          {/* <div className="social-logins">
        <span className="or">Or Log in with </span>
        <div className="form-group">
          <button type="button" className="btn btn-dark" (click)="googleAuth()">
            Google
          </button>
        </div>
      </div>

      <div>
        <a [routerLink]="AUTH_URLS.forgotPasswordUrl">
          Forgot Password?
        </a>
      </div>
      <div className="">
        Don't have an account? <a [routerLink]="AUTH_URLS.signUpUrl">Sign Up</a>
      </div> */}
        </div>
      </div>
    </div>)
}